<div class="form-group product__option">
    <div class="flex flex-col sm:flex-row mobile:items-center sm:gap-6">
        <div class="col-auto">
            <mat-calendar #calendar class="w-64" [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)" [minDate]="availableFrom" [maxDate]="availableTo" [dateFilter]="dateFilter">
            </mat-calendar>
        </div>
        <div class="col-auto">
            <div class="times-select range" *ngIf="timeType == 'time_range'">
                <app-timeRange-view [product]="product" [time]="form.get('timeRange')"></app-timeRange-view>
            </div>
        </div>

        <!-- /////////////////////////// IF SERVICE IS OF RANGE SELECTION ////////////////////////////////// -->
        <ng-container *ngIf="product.dateType == 'date_range' && range.value.start && range.value.end">
            <div class="pb-4">
                <h4 class="my-2">{{"selected_range"|translate}}:</h4>
                <div class="selected-date-range">
                    <span>{{"start_date"|translate}}:</span>
                    <b>{{range?.value?.start | date}}</b>
                    <span>{{"end_date"|translate}}:</span>
                    <b>{{range?.value?.end | date}}</b>
                </div>
            </div>

        </ng-container>
    </div>

    <!-- <ngx-daterangepicker-material [linkedCalendars]="true" [isInvalidDate]="isInvalidDate" [autoApply]="true" [startDate]="selected?.startDate"
        [endDate]="selected?.endDate" (choosedDate)="onChangeRange($event)">
    </ngx-daterangepicker-material> -->



    <!-- /////////////////////////// IF SERVICE ALLOW MULTIPLE RANGE SELECTION ////////////////////////////////// -->
    <ng-container *ngIf="product?.dateType == 'range_multi'">
        <hr>
        <h4 class="my-2">{{"selected_ranges"|translate}}:</h4>
        <div class="m-2" *ngFor="let range of range?.value?.ranges; let i = index ">
            <span class="mt-4">{{"start_date"|translate}}:{{" "+(range.startDate|date)+" "}} {{"end_date"|translate}}: {{" "+(range.endDate|date)+" "}} </span>
            <button type="button" mat-icon-button (click)="deleteRange(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </ng-container>
</div>